import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';



export class ChapterEleven extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>



                  <TextHolder text="We are pleased to present the State of Southeast Asian Tech Report, a collaboration between Monk’s Hill Ventures and Slush Singapore. This report provides a broad overview of the Southeast Asian (SEA) tech ecosystem: what makes it tick, work and grow."/>


                <TextHolder text="Our insights were gathered earlier this year through a survey. Respondents included entrepreneurs, investors, startup executives and other key players in the SEA tech startup ecosystem. Some elaborated on their views during one-on-one interviews. Taken together, the information portrayed a vibrant yet complex SEA tech startup landscape."/>

                <TextHolder text="Why did we decide to compile this report? SEA is the emerging market for tech startups in 2018. The region continues to draw attention from investors who see it as a fledgling  internet market. In recent years SEA has seen significant, game-changing growth including multi-billion dollar funding rounds, extensive government support and the rise of unicorns. SEA’s 11 economies with 630 million people have a growing middle class that is increasingly becoming affluent, many connecting to the Internet for the first time. This paradigm shift to a digital world means that SEA is quickly becoming an epicenter of internet usage, and hence a potential multi-billion dollar market for the creators and consumers of new products and services."/>

                <TextHolder text="Socio-economic, political and financial affairs of the region are well-covered by local and world media. However, media attention on the SEA startup scene is by the converted for the converted, namely by online media companies that began as startups who write for a tech- and internet-savvy readership. The mainstream media has woken up, but much needs to be done to inform and educate them on the nuances of the tech startup world and their impact on people, society, business and nations."/>

                <TextHolder text="The global startup ecosystem, including family offices and the private equity community, are also becoming aware that Asia is much larger than only China and India. The SEA ecosystem is only beginning to be understood and appreciated, especially among the corporate world and business professionals."/>


                <TextHolder text="In this report, we will highlight the ecosystem’s driving philosophies, strengths, challenges and future outlook. While there are many positive aspects, issues persist around the lack of diverse opportunities and experiences as well as the availability of human and financial capital vis-à-vis what is available in China and India. Ultimately, our report aims to give greater clarity to the development of the SEA tech ecosystem, especially to understand the drivers of today’s changes in order to better discern tomorrow’s direction."/>

                <TextHolder text="We have taken a deep dive into several aspects, adding a particular focus on founders of companies in the region. By collecting qualitative and quantitative information about these founders’ motivations, backgrounds and ambitions, we have sought to better understand the fundamental ingredients that make the SEA tech ecosystem unique. This has helped us to identify new developments and trends that will impact the ecosystem in the years and decades to come."/>

                <TextHolder text="This report, inspired by Atomico’s brilliant research on the European technology ecosystem, is a combined effort by our partners across SEA. We deeply appreciate the support of Slush Singapore, our data contributors and survey partners who have conducted additional research and kept this report as current as possible."/>
                <TextHolder textTitle="Kuo-Yi Lim"/>
                <TextHolder textTitle="Managing Partner, Monk’s Hill Ventures"/>
                <TextHolder text="" />


          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/11.js